"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableThumbnail = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Container = require("./Container.js");
var _Image = require("./Image.js");
var _Subtitle = require("./Subtitle.js");
var _Title = require("./Title.js");
var _Wrapper = require("./Wrapper.js");
var _excluded = ["img", "imgAlt", "thumbnailTitle", "subtitle", "small", "size", "truncate", "condensed"];
/**
 * The TableThumbnail cell displays an image at the beginning of a row.
 *
 * This component is being phased out in favor of using `Image` and `Text` directly. [See example](https://encore-web.spotify.net/?path=/docs/components-table-tablecell--with-image).
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablethumbnail--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table#thumbnail-cell) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableThumbnail) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=20339-15561&t=3LLzJ2F0IcvY2bkk-1)
 */
var TableThumbnail = exports.TableThumbnail = function TableThumbnail(_ref) {
  var img = _ref.img,
    imgAlt = _ref.imgAlt,
    thumbnailTitle = _ref.thumbnailTitle,
    subtitle = _ref.subtitle,
    small = _ref.small,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    truncate = _ref.truncate,
    condensed = _ref.condensed,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TableThumbnail
  }, props), img && /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    src: img,
    alt: imgAlt,
    $size: small ? 'small' : size
  }), /*#__PURE__*/_react["default"].createElement(_Wrapper.Wrapper, {
    $condensed: condensed
  }, thumbnailTitle && /*#__PURE__*/_react["default"].createElement(_Title.Title, {
    $truncate: truncate
  }, thumbnailTitle), subtitle && /*#__PURE__*/_react["default"].createElement(_Subtitle.Subtitle, {
    $truncate: truncate
  }, subtitle)));
};